export function confluenceLabels() {
	//Intentional noop. all plugin resources loaded via WRM
}

export function confluenceLabelsWRM() {
	return ['wr!com.atlassian.confluence.plugins.confluence-labels:labels-editor'];
}
